export const operations = "Operations";
export const sales = "Sales";
export const finance = "Finance";
export const executive = "Executive";
export const admin = "Admin";

export const roleTypes = [operations, sales, finance, executive, admin];
